<template>
  <div class="w-full h-full">
    <!--advantages-->
    <div class="max-w-[1200px] mx-auto flex flex-wrap justify-between gap-x-[24px] gap-y-[8px] mb-[10px] px-[10px]">
      <div v-for="adv in currentSpu.advantages" :key="adv" class="mt-[20px] text-[#223265]">
        <i class="el-icon-s-opportunity mr-[9px] inline-block"></i>
        <span>{{ adv }}</span>
      </div>
    </div>

    <BuyResidentialProxyView :shrink="true" :currentSpu="currentSpu" @buy-now="clickBuyPlan" class="mb-[20px] mt-0 min-h-[486px] max-w-[1200px]"></BuyResidentialProxyView>
    <PaymentView v-if="showPaymentView" @close="handleClosePaymentView" ref="paymentView"></PaymentView>
  </div>
</template>

<script>
import BuyResidentialProxyView from "@/components/buy-residential-proxy-view.vue"
import PaymentView from "@/views/payment/payment-view.vue"

export default {
  name: 'residential',
  components: {
    BuyResidentialProxyView,
    PaymentView,
  },

  data() {
    return {
      Loading: false,
      showPaymentView: false,

      spu: {
        type: 1, // 1-动态代理
        name: 'Residential Proxies',
        url: '/ucenter/residential/',
        ipAmount: 'unlimited',
        subAccount: true,
        countrySelection: 1, // 1-support 2-continent
        dedicatedServer: false,
      },

    }
  },
  inject: ['updateCurrentMenuUrl'],
  computed: {
    currentSpu() {
      this.spu.advantages = this.$t('residential.advantages');
      this.spu.ipAmount = this.$t('residential.ip_amount');
      return this.spu;
    },
  },
  watch: {
  },
  created() {
    this.updateCurrentMenuUrl('/ucenter/residential/');
  },
  methods: {
    
    clickBuyPlan(item, duration) {
      let that = this;
      if (this.$store.state.isLogin) {
        item.source = '/ucenter/residential/';
        that.showPaymentView = true;
        that.$nextTick(() => {
          if (that.$refs.paymentView) {
            that.$refs.paymentView.updateInfo(item)
          }
        })
      } else {
        that.$router.push({path:'/login', query: {redirect: this.$route.fullPath}})
      }
    },

    handleClosePaymentView() {
      this.showPaymentView = false;
    },
  }
}

</script>
